import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { Language } from './types';

export type StoreState = {
  languages: Language[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
};

const initialState: StoreState = {
  languages: [],
  isLoading: false,
  failedToLoad: false,
  hasData: false,
};

export enum LanguageActionKeyPrefixes {
  FETCH_LANGUAGES = 'languages/fetchLanguages',
}

export type LanguagesPayload = {
  languages: Language[];
};

export const getLanguages = async (): Promise<Language[]> =>
  await fetchFromOldApi('/json/company/language?format=full').then((r) =>
    r.json(),
  );

export const fetchLanguages = createAsyncThunk<LanguagesPayload, undefined>(
  LanguageActionKeyPrefixes.FETCH_LANGUAGES,
  async (): Promise<LanguagesPayload> => {
    return {
      languages: await getLanguages(),
    };
  },
);

export const languagesSlice = createSlice({
  name: '~/data/language',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLanguages.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<LanguagesPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.languages = action.payload.languages;
    },
    [fetchLanguages.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchLanguages.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const languagesReducer = languagesSlice.reducer;
